import React, { useState } from 'react';
import { searchPlaces } from '../../api/PlaceApi';
import useLoadingStore from '../../store/loadingStore';
import { IoSearch, IoLocationOutline, IoChevronForward } from 'react-icons/io5';
import useAuthStore from "../../store/authStore";

const KakaoPlaceContainer = ({ onPlaceSelect }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [places, setPlaces] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasSearched, setHasSearched] = useState(false);
    const { setIsLoading } = useLoadingStore();
    const { member } = useAuthStore();

    const handleSearch = async (term, page = 1, append = false) => {
        if (!term.trim()) {
            alert('검색어를 입력해주세요.');
            return;
        }

        setIsLoading(true);
        setHasSearched(true);

        try {
            const searchRequest = {
                term: term.trim(),
                latitude: member.latitude,
                longitude: member.longitude,
                page,
            };

            const response = await searchPlaces(searchRequest);

            if (append) {
                setPlaces(prev => [...prev, ...response.places]);
            } else {
                setPlaces(response.places);
            }

            setHasMore(response.hasMore);
            setCurrentPage(page);
        } catch (error) {
            console.error('장소 검색 실패:', error);
            alert('장소 검색 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearchPress = () => {
        setCurrentPage(1);
        handleSearch(searchTerm, 1, false);
    };

    const handleLoadMore = () => {
        if (hasMore && searchTerm.trim()) {
            handleSearch(searchTerm, currentPage + 1, true);
        }
    };

    const handlePlaceClick = (place) => {
        if (onPlaceSelect) {
            onPlaceSelect(place);
        }
    };

    return (
        <div className="flex flex-col h-full">
            {/* 검색 입력 */}
            <div className="p-4 border-b border-gray-200 bg-white">
                <div className="flex space-x-2">
                    <div className="w-3/4 flex items-center border border-gray-300 rounded-lg">
                        <div className="pl-3">
                            <IoSearch size={20} className="text-gray-400" />
                        </div>
                        <input
                            type="text"
                            placeholder="장소명을 입력하세요"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleSearchPress()}
                            className="w-full px-3 py-2 outline-none"
                            autoFocus
                        />
                    </div>
                    <button
                        onClick={handleSearchPress}
                        className="w-1/4 px-2 py-2 bg-amber-500 text-white rounded-lg active:bg-amber-600 whitespace-nowrap"
                    >
                        검색
                    </button>
                </div>
            </div>

            {/* 결과 목록 */}
            <div className="flex-1 overflow-y-auto">
                {places.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-full text-gray-500 px-4">
                        <div className="h-20"></div>
                        <IoLocationOutline size={72} className="text-gray-400" />
                        <div className="h-10"></div>
                        <p className="text-center text-gray-500">
                            {hasSearched
                                ? '검색 결과가 없습니다'
                                : '장소명을 입력하고 검색 버튼을 눌러주세요'}
                        </p>
                    </div>
                ) : (
                    <div>
                        {places.map((place, index) => (
                            <div
                                key={`${place.name}-${place.address}-${index}`}
                                onClick={() => handlePlaceClick(place)}
                                className="flex items-center p-4 border-b border-gray-200 active:bg-gray-50 cursor-pointer"
                            >
                                <div className="flex-1">
                                    <h3 className="font-medium text-gray-900 mb-1">{place.name}</h3>
                                    <p className="text-sm text-gray-600 mb-1">{place.address}</p>
                                    <p className="text-xs text-gray-500">{place.phone || ' '}</p>
                                </div>
                                <IoChevronForward size={16} className="text-gray-400" />
                            </div>
                        ))}

                        {/* 더보기 버튼 */}
                        {hasMore && (
                            <div className="p-4 text-center">
                                <button
                                    onClick={handleLoadMore}
                                    className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 active:bg-gray-50"
                                >
                                    더보기
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default KakaoPlaceContainer;
